import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'

interface BaseLayoutProps {
  children?: ReactNode
}

const BaseLayoutWrapper = styled.div`
  flex: 1;
  height: 100%;
`

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  return <BaseLayoutWrapper>{children || <Outlet />}</BaseLayoutWrapper>
}

export default BaseLayout
